import React from 'react';
import './Background.css';

function CloudBackground() {
  return (
    // <div className="cloudContainer">
      <div class="area" >
              <ul class="circles">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
              </ul>
      {/* </div> */}
    </div>
  );
}

export default CloudBackground;
